<script>
  import { Line } from 'vue-chartjs'

  export default {
    extends: Line,
    props: ['waktuGraph','countGraph'],
    data () {
      return {
        datacollection: {
          labels: this.waktuGraph,
          datasets: [
            {
              borderColor: '#474A8C',
            backgroundColor: '#474A8C',
            fill: false,
            borderWidth: 5,
            xAxisID: 'xAxis1',
            label: 'Grafik Count',
              data: this.countGraph
            }
          ]
        },
        options: {
          maintainAspectRatio: false,
          elements: {
            point: {
              radius: 0
            }
          },
          spanGaps: true,
          legend: {
            display: false,
          },
          responsive: true,
          plugins: {
            datalabels: {
              color: 'black',
            },
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: false,
                suggestedMin: 10 ,
                suggestedMax: 20,
                steps: 10,
                stepValue: 5,
              }
            }],
            xAxes: [{
              id: 'xAxis1',
              type: "category",
              gridLines: {
                display: false
              },
              ticks: {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                maxTicksLimit: 20,
                callback: function(label) {
                  var waktu = label.split(" ")[1];
                  if (waktu == "08:00" || waktu == "14:00" || waktu == "23:00") {
                    return waktu;
                  }
                }
              }
            }, {
              id: 'xAxis2',
              type: "category",
              gridLines: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
              ticks: {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                maxTicksLimit: 20,
                callback: function(label) {
                  var tanggal = label.split(" ")[0];
                  var waktu = label.split(" ")[1];
                  // console.log(label)
                  if (waktu == "12:00") {
                    return tanggal;
                    // } else {
                    // 	return false;
                  }
                }
              }
            }],

          },

        }
      }
    },
    mounted () {
      this.renderChart(this.datacollection, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Home/LineChart.vue